import React from "react";
import { FailoverTableRow, MaintenanceTableRow } from "./Types";
import { RecordDetailsModal } from "./RecordDetailsModal";

/**
 * The full record of one outage. Shared by the Outages list and the action
 * center's "Attention required" list, so both open the same thing.
 *
 * The description leads because most automatic records carry nothing else —
 * a modal that only showed `detail` opened empty for them.
 */
export function OutageDetailsModal({
  outage,
  onClose,
}: {
  /** The outage to show; `null` closes the modal. */
  outage: FailoverTableRow | null;
  onClose: () => void;
}) {
  return (
    <RecordDetailsModal
      isOpen={outage !== null}
      title="Outage Details"
      facts={[
        { label: "ID", value: outage?.incidentId },
        { label: "Date", value: outage?.date },
        { label: "Customer", value: outage?.customer },
        { label: "Site", value: outage?.site },
        { label: "Duration", value: outage?.duration },
      ]}
      paragraphs={[outage?.description, outage?.detail]}
      onClose={onClose}
    />
  );
}

/** The full record of one maintenance window — the text a list row can only clip. */
export function MaintenanceDetailsModal({
  maintenance,
  onClose,
}: {
  /** The window to show; `null` closes the modal. */
  maintenance: MaintenanceTableRow | null;
  onClose: () => void;
}) {
  return (
    <RecordDetailsModal
      isOpen={maintenance !== null}
      title="Maintenance Details"
      facts={[
        { label: "Date", value: maintenance?.date },
        { label: "Customer", value: maintenance?.customer },
        { label: "Duration", value: maintenance?.duration },
      ]}
      paragraphs={[maintenance?.description]}
      onClose={onClose}
    />
  );
}
